var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.894 14.174l-2.043-2.044a2.343 2.343 0 00-3.316 0l-.417.417A45.305 45.305 0 017.45 6.87l.417-.417a2.348 2.348 0 000-3.315l-2.048-2.04a2.403 2.403 0 00-3.319 0L1.383 2.219a3.317 3.317 0 00-.416 4.162A45.145 45.145 0 0013.61 19.027a3.346 3.346 0 004.167-.416l1.12-1.122a2.34 2.34 0 000-3.314z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b26f5e44.svg";
export { ForwardRef as ReactComponent };